<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-contributi-fondo-perduto page-operative-data-analysis-contributi-fondo-perduto-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo contributo a fondo perduto</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.contributi-fondo-perduto' }">Torna alla lista</app-router-link>
      </div>
      <FormContributoFondoPerduto @saved="saveContributoFondoPerduto" />
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage.js';

export default {
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle.vue'),
    FormContributoFondoPerduto: () => import('@/views/components/Operative/Form/FormContributoFondoPerduto.vue'),
    AppRouterLink: () => import('@/views/components/Layout/AppRouterLink.vue'),
  },
  methods: {
    saveContributoFondoPerduto (contributoFondoPerduto) {
      this.$api.addContributoFondoPerduto(this.company.id, contributoFondoPerduto)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.contributi-fondo-perduto',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
